import React from 'react'
import { Box, Carousel, RichButton, MOBILE } from 'chemistry'
import { useSelector } from 'react-redux'
import { SHOW_TOP_SUBCATEGORIES } from 'common/constants'
import { isFlagInGA, pushFlagToDatalayer } from '../../../../common/gtmEvents'

const TopSubcategories = ({ filters }) => {
  const categoryImages = useSelector(({ data }) => data.categoryImages)
  const flagsToGA = useSelector(store => store.data?.flags?.flagsToGA)

  const subcategories = filters?.collection.find(f => f.name === 'group_id')?.items || []
  if (subcategories.length < 1) return null
  return (
    <Box
      position='relative'
      zIndex='2'
      sx={{
        marginTop: '24px',
        marginRight: 0,
        [MOBILE]: {
          marginTop: '16px',
          marginRight: '-16px'
        }
      }}
    >
      <Carousel hideScrollBar={true}>
        {(styles = {}, ref) =>
          subcategories.map((category, index) => (
            <Box
              sx={{
                marginRight: '16px'
              }}
              key={`category-${index}`}
              ref={ref}
              onClick={() => {
                if (isFlagInGA({ flagsToGA, ldFlag: SHOW_TOP_SUBCATEGORIES })) {
                  pushFlagToDatalayer({
                    ldFlag: 'show-top-subcategories',
                    ldVariation: 'top-subcategory-clicked'
                  })
                }
              }}
            >
              <RichButton
                url={category.href}
                title={category.label}
                openInNewTab={false}
                withImg={true}
                image={{
                  image: {
                    url: categoryImages[category.value]?.replace('/origin', `/424x424/origin`)?.replace('.png', `.webp`)
                  },
                  imageAlt: category.value
                }}
                imageStyles={{ width: '48px', height: '48px' }}
                showSquareImage={true}
                hideArrow={true}
              />
            </Box>
          ))
        }
      </Carousel>
    </Box>
  )
}

export default TopSubcategories
